export enum WorkDocumentType {
  Conflicts = "Conflicts",
  ClientPolicy = "ClientPolicy",
  VendorPolicy = "VendorPolicy"
}
